/* eslint-disable no-underscore-dangle, no-nested-ternary, max-len */
import { CONFIG } from '../config';

export default class BfvVideoUpload {

  /**
   * holds the errormessages
   * @type {Map<string, any>}
   */
  errorMessages = new Map([
    ['size', 'Bitte beachte, die maximal zulässige Dateigröße.'],
    ['fileType', 'Bitte beachte, dass nur Videos der Formate MP4, WBM und WMV zulässig sind.'],
    ['submit', 'Bitte überprüfe, ob alle Pflichtfelder ausgefüllt sind.'],
    ['uploadError', 'Der Upload ist fehlgeschlagen. Bitte versuche es noch einmal.'],
  ]);

  hasError = false;

  constructor(options = {}) {
    this.$root = options.element;
    this.$buttonAdd = this.$root.querySelector('button.js-video-add');
    this.$buttonSubmit = this.$root.querySelector('button.js-video-submit');
    this.$input = this.$root.querySelector('input[type="file"]');
    this.$titleInput = this.$root.querySelector('input[name="title"]');
    this.isLoggedIn = false;
    this.successUrl = this.$root.dataset.successUrl;
    this.acceptedFileTypes = this.$root.dataset.acceptedFileTypes;
    this.maxFileSize = this.$root.dataset.maxFileSize;
    this.$videoUrl = '';
    this.$previewVideoDomNode = this.$root.querySelector('.bfv-video-input__preview');
    this.$errorNode = this.$root.querySelector('.bfv-video-input__error-message');
    this.$inputRoot = this.$root.querySelector('.bfv-video-input');
    this.$identifier = this.$root.dataset.identifier;
    this.requestApiUrl = this.$root.dataset.apiUrl;
    this.$inputHint = this.$root.querySelector('.input__hint');
    this.$videoUploadUrl = '';

    this.videoFile = {};
    this.fileSizeInBytes = 0;

    this.chunkSizeInBytes = this.$root.dataset.chunkSize;
    this.chunkReqs = [];

    this.$progress = this.$root.querySelector('.bfv-video-upload-form__progress');
    this.$progressBar = this.$root.querySelector('.bfv-video-upload-form__progress-bar');
    this.$status = this.$root.querySelector('.bfv-video-upload-form__status');

    this.auth = this.$root.dataset.authToken;
    this.uploadVideoEvent = null;
    this.$videoSelect = this.$root.querySelector('js-video-upload-selection');
    this.videoIsSelected = false;
    this.requiredInputsAreValid = false;
    this.$requiredInputs = this.$root.querySelectorAll('.input--required');

    this.loaderWrapper = this.$root.querySelector('.bfv-video-upload-form__loader-wrapper');
    this.contentWrapper = this.$root.querySelector('.bfv-video-upload-form__form-wrapper');
    this.errorMessageBox = this.$root.querySelector('.bfv-video-upload-form__error-message');
  }

  init() {
    this.bindEvents();
  }

  bindEvents() {
    this.$buttonAdd.addEventListener('click', () => {
      this.$input.click();
    });

    if (this.$buttonSubmit) {
      this.$buttonSubmit.addEventListener('click', async () => {
        BfvVideoUpload.showContent(this.loaderWrapper);
        await this.sendVideoInformationToGetTheVideoUploadUrl();
        this.validation();
      });
    }

    this.$titleInput.addEventListener('change', () => {
      this.$title = this.$titleInput.value;
    });

    this.$input.addEventListener('change', (event) => {
      if (this.videoIsSelected) {
        this.removeVideoData();
      }

      this.getFileInformation(event);
      this.valid = false;
      this.videoFileValidation();

      if (this.valid) {
        this.setFileName();
        this.setVideoData();
        this.toggleButtonName();
        this.videoIsSelected = true;

        this.enableSubmitButton();
      }
    });


    if (this.$requiredInputs) {
      Array.prototype.slice.call(this.$requiredInputs)
        .forEach(($entry) => {
          $entry.addEventListener('change', () => {
            this.checkIfRequiredFieldsAreFilled($entry);

            if (this.requiredInputsAreValid) {
              this.enableSubmitButton();
            } else {
              this.disableSubmitButton();
            }
          });
        });
    }

    if (this.$videoSelect) {
      this.uploadVideoEvent = document.createEvent('Event');
      this.uploadVideoEvent.initEvent(CONFIG.events.BFV_UPLOADED_VIDEO, true, true);

    }
  }

  getFileInformation(event) {
    const target = event.target;
    this.file = target.files[0];
    if (this.file) {
      this.type = this.file.type;
      this.fileName = this.file.name;
      this.size = this.file.size;
      this.$videoUrl = URL.createObjectURL(event.target.files[0]);
      this.__renderError(false);
    }
  }

  /**
   * check if video file size and type are valid
   */
  videoFileValidation() {
    if (!this.file) {
      this.valid = false;
      return;
    }

    const videoSize = this.checkIfVideoSizeIsValid();
    const videoType = this.checkIfVideoTypeIsValid();

    if (videoSize && videoType) {
      this.valid = true;
    }

    this.toggleButtonName();
  }

  toggleButtonName() {
    const buttonName = this.$buttonAdd.querySelector('.btn__text');
    if (this.valid) {
      buttonName.innerHTML = 'Video ändern';
    } else {
      buttonName.innerHTML = 'Video hochladen';
    }
  }

  setFileName() {
    const domElement = this.$root.querySelector('.js-preview-video-name');
    domElement.innerHTML = this.fileName;
  }

  checkIfRequiredFieldsAreFilled($entry) {
    const inputElement = $entry.getElementsByTagName('input')[0];

    if (inputElement.value) {
      this.requiredInputsAreValid = true;
    }
  }

  enableSubmitButton() {
    if (this.valid && this.requiredInputsAreValid) {
      this.$buttonSubmit.removeAttribute('disabled');
    }
  }

  disableSubmitButton() {
    this.$buttonSubmit.setAttribute('disabled', true);
  }

  /**
   * set video url, type and Id to provide video preview
   */
  setVideoData() {
    const video = this.$root.getElementsByTagName('video')[0];
    video.src = this.$videoUrl;
    video.setAttribute('type', this.type);
    video.setAttribute('id', this.fileName);
    this.$previewVideoDomNode.classList.add('bfv-video-input__preview--visible');
    video.load();
  }

  uploadVideoChunks() {
    this.videoFile = this.$input.files[0];
    this.fileSizeInBytes = this.videoFile.size;

    const chunkSizeInBytes = parseInt(this.chunkSizeInBytes, 10);
    const totalChunkCount = Math.ceil((this.fileSizeInBytes / chunkSizeInBytes));

    this.$progress.classList.add('bfv-video-upload-form__progress--active');

    let start = 0;
    let end = chunkSizeInBytes;
    this.chunkReqs = [];

    for (let chunkCount = 1; chunkCount <= totalChunkCount; chunkCount += 1) {
      const chunk = this.videoFile.slice(start, end);
      const additionalHeaders = [];

      const headerTotalChunk = {
        name: 'Mi24-Upload-Total-Chunks',
        value: totalChunkCount,
      };

      const headerCurrentChunk = {
        name: 'Mi24-Upload-Current-Chunk',
        value: chunkCount,
      };

      additionalHeaders.push(headerTotalChunk);
      additionalHeaders.push(headerCurrentChunk);

      const formData = new FormData();
      formData.append('data', chunk);

      chunk.isUploaded = false;
      this.sendChunks(chunk, additionalHeaders);

      start = end;
      end = Math.min((end + chunkSizeInBytes), this.fileSizeInBytes);
    }
  }

  sendChunks(chunk, additionalHeaders) {
    window.divae.restApi
      .sendData(this.$videoUploadUrl, chunk, 'application/octet-stream', false, additionalHeaders)
      .then((_response) => {
        if (_response.status !== 202 && _response.status !== 201 && _response.status !== 200) {
          BfvVideoUpload.showContent(this.errorMessageBox);
          BfvVideoUpload.showContent(this.contentWrapper);
          BfvVideoUpload.hideContent(this.loaderWrapper);
        } else {
          const chunkCopy = new Blob([chunk], { type: chunk.type });
          const chunkMetadata = {
            blob: chunkCopy,
            isUploaded: true,
            size: chunk.size,
          };
          this.chunkReqs.push(chunkMetadata);
          // Calculate overall progress based on uploaded chunk sizes
          const uploadedChunkSize = this.chunkReqs.filter(req => req.isUploaded).reduce((acc, req) => acc + req.size, 0);
          const progress = (uploadedChunkSize / this.fileSizeInBytes) * 100;

          // Update progress bar width and status
          this.$progressBar.style.width = `${progress}%`;
          this.$progressBar.style.height = '100%';
          this.$status.innerText = `${Math.round(progress)}% geladen`;

          if (uploadedChunkSize === this.fileSizeInBytes) {
            // All chunks uploaded, redirect to success page
            this.redirectSuccessPage();
          }
        }
      })
      .catch((error) => {
        // eslint-disable-next-line no-console
        console.error('Error occured while sendingChucks: ', error);
      });
  }

  redirectSuccessPage() {
    window.location.href = this.successUrl;
  }

  checkIfVideoSizeIsValid() {
    if (this.maxFileSize < this.size) {
      this.__renderError('size');
      return false;
    }
    return true;
  }

  checkIfVideoTypeIsValid() {
    if (!(this.acceptedFileTypes.includes(this.type))) {
      this.__renderError('fileType');
      return false;
    }
    return true;
  }

  /**
   * select Error Message
   * @param type
   * @returns {*}
   * @private
   */
  __selectError(type) {
    return this.errorMessages.get(type);
  }

  /**
   * put error text in DOM
   * @param msg
   * @private
   */
  __setError(msg = false) {
    if (msg) {
      this.$errorNode.innerHTML = msg;
      this.$inputRoot.classList.add('input--error');
      if (this.$inputHint) {
        this.$inputHint.style.display = 'none';
      }
    } else {
      this.$errorNode.innerHTML = '';
      this.$inputRoot.classList.remove('input--error');
      if (this.$inputHint) {
        this.$inputHint.style.display = 'block';
      }
    }
  }

  /**
   * renders error messages
   * @param error
   * @private
   */
  __renderError(error) {
    const errorMsg = this.__selectError(error);
    this.__setError(errorMsg);
    this.hasError = !!errorMsg;
    this.valid = false;
  }

  removeVideoData() {
    const video = this.$root.getElementsByTagName('video')[0];
    video.src = '';
    video.setAttribute('type', '');
    video.setAttribute('id', '');
    this.$previewVideoDomNode.classList.remove('bfv-video-input__preview--visible');
  }


  sendVideoInformationToGetTheVideoUploadUrl() {
    const id = this.$identifier;

    let data = { fileName: this.fileName, videoTitle: this.$title };
    data = JSON.stringify(Object.assign({}, data));

    return window.divae.restApi
      .sendData(`${this.requestApiUrl}/${id}`, data, 'application/json', false)
      .then((_response) => {
        this.$videoUploadUrl = _response.uploadUrl;
      })
      .catch((error) => {
        console.error(error);
      });
  }

  checkIfAllInformationAreCollected() {
    if (this.$videoUploadUrl && this.$identifier && this.valid && this.requiredInputsAreValid) {
      return true;
    }
    return false;
  }

  static showContent(elements) {
    if (elements) {
      const content = elements;
      content.style.display = 'block';
    }
  }


  static hideContent(elements) {
    if (elements) {
      const content = elements;
      content.style.display = 'none';
    }
  }

  validation() {
    if (this.checkIfAllInformationAreCollected()) {
      BfvVideoUpload.hideContent(this.contentWrapper);
      this.uploadVideoChunks();
    } else {
      this.__renderError('submit');
    }
  }
}



// WEBPACK FOOTER //
// ./src/javascript/main/BfvVideoUpload/index.js